(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/components/navigation-buttons.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/components/navigation-buttons.js');

'use strict';

const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const NavigationButtons = () => {
  const wrapperRef = React.useRef(null);
  React.useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.classList.add('animate-on-load');
      setTimeout(() => {
        if (wrapperRef.current) {
          wrapperRef.current.classList.remove('animate-on-load');
        }
      }, 3000); 
    }
  }, []);
  const defaultComponents = React.createElement("div", {
    className: "eurojackpot-navigation-buttons"
  }, React.createElement("div", {
    className: "buttons-body"
  }, React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => svs.utils.url.navigate("eurojackpot/forlang-spel"),
    type: "button"
  }, "F\xF6rl\xE4ng spel"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => svs.utils.url.navigate("eurojackpot/resultat"),
    type: "button"
  }, "Resultat"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => svs.utils.url.navigate("eurojackpot/andelsspel"),
    type: "button"
  }, "Andelsspel"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => svs.utils.url.navigate("eurojackpot/systemspel"),
    type: "button"
  }, "Systemspel"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => svs.utils.url.navigate("eurojackpot/prenumeration"),
    type: "button"
  }, "Prenumeration"), React.createElement(Button, {
    block: true,
    className: "btn btn-eurojackpot with-icon",
    onClick: () => svs.utils.url.navigate("eurojackpot/spelguide"),
    type: "button"
  }, "Spelguide", ' ', React.createElement("span", null, React.createElement(Icon, {
    icon: "information",
    size: "300"
  })))));
  const selfServiceComponents = React.createElement(React.Fragment, null, React.createElement("div", {
    className: "eurojackpot-navigation-buttons"
  }, React.createElement("div", {
    className: "buttons-body"
  }, React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => svs.utils.url.navigate("eurojackpot/systemspel"),
    type: "button"
  }, "Systemspel"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => svs.utils.url.navigate("eurojackpot/resultat"),
    type: "button"
  }, "Resultat"))), React.createElement("div", {
    className: "eurojackpot-navigation-button-wrapper"
  }, React.createElement("div", {
    className: "wrapper-body"
  }, React.createElement(Button, {
    block: true,
    className: "btn btn-eurojackpot with-icon",
    onClick: () => svs.utils.url.navigate("eurojackpot/spelguide"),
    type: "button"
  }, "Spelguide", ' ', React.createElement("span", null, React.createElement(Icon, {
    icon: "information",
    size: "300"
  }))))));
  return React.createElement("div", {
    className: "eurojackpot-navigation-buttons-wrapper",
    ref: wrapperRef
  }, isSelfService ? selfServiceComponents : defaultComponents);
};
setGlobal('svs.eurojackpot.react.components', {
  NavigationButtons
});

 })(window);